import { render, staticRenderFns } from "./switch-icon.vue?vue&type=template&id=2dfa81c6&scoped=true"
import script from "./switch-icon.vue?vue&type=script&lang=js"
export * from "./switch-icon.vue?vue&type=script&lang=js"
import style0 from "./switch-icon.vue?vue&type=style&index=0&id=2dfa81c6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfa81c6",
  null
  
)

export default component.exports